var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.color,attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"11.314","height":"8.485","viewBox":"0 0 11.314 8.485"}},[_c('g',{attrs:{"transform":"translate(-546.343 -1215.172)"}},[_c('path',{staticClass:"a",attrs:{"d":"M550.586,1223.657l-4.243-4.243,1.414-1.414,2.828,2.828,5.657-5.657,1.414,1.414Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }